import { TrainingsCategoriesDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DestroyCategoryDocument,
  DestroyCategoryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDestroyCategory = () => {
  const [destroyCategory, { loading }] = useMutation(DestroyCategoryDocument, {
    extractorFn: (data) => data.trainingsMutations.deleteTrainingsCategory,
  })

  return {
    loading,
    destroyCategory(variables: DestroyCategoryMutationVariables) {
      return destroyCategory({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingsCategoriesDataTableDocument],
      })
    },
  }
}
